import { createGenericStore } from '../../../shared/store/genericStore';
import { DiagramModel } from '@diagram/model/diagram.model';
export const useDashboardDiagramStore = createGenericStore<DiagramModel>();
